import React from "react";

import { ContractState } from "./contract.reducer";

const base = "CONTRACT";

export const actionTypes = {
  GET_CONTRACT: `${base}/GET_CONTRACT`,
  CONTRACT_LOADING: `${base}/CONTRACT_LOADING`,
  SET_CONTRACT_CLASSIFICATION: `${base}/SET_CONTRACT_CLASSIFICATION`,
  SET_SENDER_ROLE: `${base}/SET_SENDER_ROLE`,
  GET_CONTRACT_ACTIVITIES: `${base}/GET_CONTRACT_ACTIVITIES`,
} as const;

export type GetContractActionType = {
  type: typeof actionTypes.GET_CONTRACT;
  payload: Pick<ContractState, "contract">;
};

export const getContractAction =
  (dispatch: React.Dispatch<GetContractActionType>) =>
  (payload: ContractState["contract"]): void =>
    dispatch({
      type: actionTypes.GET_CONTRACT,
      payload: { contract: payload },
    });

export type GetContractActivitiesType = {
  type: typeof actionTypes.GET_CONTRACT_ACTIVITIES;
  payload: Pick<ContractState, "contractActivities">;
};

export const getContractActivities =
  (dispatch: React.Dispatch<GetContractActivitiesType>) =>
  (payload: ContractState["contractActivities"]): void =>
    dispatch({
      type: actionTypes.GET_CONTRACT_ACTIVITIES,
      payload: { contractActivities: payload },
    });

export type setContractTypeAction = {
  type: typeof actionTypes.SET_CONTRACT_CLASSIFICATION;
  payload: Pick<ContractState, "contractType">;
};

export const setContractType =
  (dispatch: React.Dispatch<setContractTypeAction>) =>
  (payload: ContractState["contractType"]): void =>
    dispatch({
      type: actionTypes.SET_CONTRACT_CLASSIFICATION,
      payload: { contractType: payload },
    });

export type setSenderRoleAction = {
  type: typeof actionTypes.SET_SENDER_ROLE;
  payload: Pick<ContractState, "senderRole">;
};

export const setSenderRole =
  (dispatch: React.Dispatch<setSenderRoleAction>) =>
  (payload: ContractState["senderRole"]): void =>
    dispatch({
      type: actionTypes.SET_SENDER_ROLE,
      payload: { senderRole: payload },
    });
